const serverBaseURL = process.env.VUE_APP_SERVER_BASE_URL ?? '';

export default Object.freeze({
    serverBaseURL,
    apiServerEndpoint: `${serverBaseURL}/api`,
    authServerEndpoint: `${serverBaseURL}/auth`,
    clientBaseURL: process.env.VUE_APP_CLIENT_BASE_URL ?? 'https://xprt.jobs',
    recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
    siteUsername: process.env.VUE_APP_SITE_USERNAME,
    sitePassword: process.env.VUE_APP_SITE_PASSWORD,
    umamiWebsiteId: process.env.VUE_APP_UMAMI_WEBSITE_ID,
    umamiScriptSrc: process.env.VUE_APP_UMAMI_SCRIPT_SRC
});
